<div class="row container_fieldset">
 <div class="col-sm-12">
   <fieldset class="form-group">
    <legend>Arbitrato</legend>
     <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Tipo arbitrato'"
         [valueInput]="ctxBodyFascicolo.fascicolo.tipoArbitrato ? ctxBodyFascicolo.fascicolo.tipoArbitrato.label : ''"></div>
     <div labelTextInput class="col-sm-4 bloccodati"
         [typeLabel]="'boolean'" [labelInput]="'Collegio arbitrale'"
         [valueInput]="ctxBodyFascicolo.fascicolo.collegioArbitrale"></div>
     <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
         [labelInput]="'Data richiesta arbitrato'"
         [valueInput]="ctxBodyFascicolo.fascicolo.dataRichiestaArbitrato"></div>
   </fieldset>
 </div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
